import useTranslation from 'next-translate/useTranslation'
import Head from 'next/head'
import { Proteins } from 'models/Pet'
import { FrozenRecipeDetail } from 'features/Recipes/FrozenRecipeDetail'

export default function RecipePage() {
  const { t } = useTranslation()

  // prettier-ignore
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Recipe',
    name: 'Duck Patty Recipe',
    description:
      "Naturally packed with antioxidants and highly digestible, our duck recipe is a fan favorite. A flavorful choice that's complete and balanced for dogs of all life stages. Formulated by a PhD nutritionist.",
    image: 'https://wefeedraw.com/assets/recipes/categories/individual/hero-duck.webp',
    author: {
      '@type': 'Organization',
      name: 'We Feed Raw'
    },
    publisher: {
      '@type': 'Organization',
      name: 'We Feed Raw',
      logo: {
        '@type': 'ImageObject',
        url: 'https://wefeedraw.com/assets/isotype-background-brown.svg'
      }
    },
    recipeCategory: 'Raw Dog Food',
    recipeCuisine: 'Pet Food',
    prepTime: 'PT1M',
    cookTime: 'PT0M',
    recipeYield: 'Yield varies based on the size and dietary needs of your dog',
    recipeIngredient: [
      'Duck',
      'Turkey Gizzards',
      'Turkey Tails',
      'Turkey Liver',
      'WFR vitamin + mineral mix'
    ],
    keywords: 'raw dog food duck', 
    nutrition: {
      '@type': 'NutritionInformation',
      calories: '47 kcal M.E./oz',
      proteinContent: '(min) 12.6%',
      fatContent: '(min) 10.6%',
      fiberContent: '(max) 1.0%',
      additionalProperty: [
        {
          '@type': 'PropertyValue',
          name: 'Calories per kg',
          value: '1650 kcal M.E./kg'
        }
      ]
    }
  };

  const jsonLdString = JSON.stringify(schema)

  return (
    <div>
      <Head>
        <title>{t('recipes:DUCK.page-title')}</title>
        <meta name="title" content={t('recipes:DUCK.meta-title')} />
        <meta name="description" content={t('recipes:DUCK.meta-description')} />
        <link rel="canonical" href="https://wefeedraw.com/recipes/duck" />
        <script
          id="schema-script"
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: jsonLdString }}
        />
      </Head>

      <main>
        <FrozenRecipeDetail protein={Proteins.DUCK} /> 
      </main>
    </div>
  )
}
